import { LmIconFilledImageVideoColorPalette, LmIconOutlineImageVideoColorPalette } from '@mes-ui/lemma/icons';

import { WidgetIconProps } from '../types';

const IconCivilUnitsCommon = ({ iconType, ...rest }: WidgetIconProps) =>
  iconType === 'outlined' ? (
    <LmIconOutlineImageVideoColorPalette {...rest} />
  ) : (
    <LmIconFilledImageVideoColorPalette {...rest} />
  );

export default IconCivilUnitsCommon;
